import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faPlus,
    faEdit,
    faTrash,
    faTimes,
    faUser
} from "@fortawesome/free-solid-svg-icons";

import Breadcrumb from "../../../components/Ui_Element/Breadcrumb";
import DotLoader from "../../../components/Ui_Element/DotLoader";
import { post, getlist, deleteitem } from "../../../contexts/apicontexts";
import config from "../../../config";

const PAGE_SIZE = 10;

export default function Employee() {
    const [employees, setEmployees] = useState([]);
    const [designations, setDesignations] = useState([]);
    const [departments, setDepartments] = useState([]);
    const [roles, setRoles] = useState([]);
    const [page, setPage] = useState(1);
    const [isOpen, setIsOpen] = useState(false);
    const [isLoder, setIsLoder] = useState(false);
    const [errors, setErrors] = useState({});

    // Initial Form State
    const initialFormState = {
        Id: 0,
        EmployeeNumber: "",
        FullName: "",
        EmployeeCode: "",
        WorkEmail: "",
        PersonalEmail: "",
        Mobile: "",
        EmploymentStatus: "",
        Gender: "",
        JoiningDate: "",
        DateOfBirth: "",
        DesignationID: "",
        DepartmentID: "",
        ManagerID: "",
        UserID: "",
        RoleName: "",
        PhotoUrlWithPath: ""
    };

    const [formState, setFormState] = useState(initialFormState);
    const [selectedFile, setSelectedFile] = useState(null);
    const [filePreview, setFilePreview] = useState(null);
    const [filePreviewPath, setFilePreviewPath] = useState("");

    useEffect(() => {
        fetchEmployees();
        fetchDropdowns();
    }, []);

    const fetchEmployees = async () => {
        setIsLoder(true);
        try {
            const response = await getlist(`${config.baseurl}Employee/getlist`);
            if (response?.status === 200) {
                setEmployees(response.data || []);
            }
        } catch (error) {
            console.error("Error fetching employees:", error);
        } finally {
            setIsLoder(false);
        }
    };

    const getImageCandidates = (path) => {
        if (!path) return [];
        console.log("path", path);

        const normalize = (value) => String(value).trim().replace(/\\/g, "/");
        const normalizedPath = normalize(path);

        if (
            normalizedPath.startsWith("blob:") ||
            normalizedPath.startsWith("data:") ||
            normalizedPath.startsWith("http://") ||
            normalizedPath.startsWith("https://")
        ) {
            return [normalizedPath];
        }

        let cleanPath = normalizedPath.startsWith("~")
            ? normalizedPath.substring(1)
            : normalizedPath;

        if (!cleanPath.startsWith("/")) {
            cleanPath = `/${cleanPath}`;
        }
        cleanPath = cleanPath.replace(/\/{2,}/g, "/");

        let apiBase = "";
        let serverOrigin = "";
        try {
            const url = new URL(config.baseurl, window.location.origin);
            apiBase = url.href.replace(/\/+$/, "");
            serverOrigin = url.origin;
        } catch (e) {
            apiBase = (config.baseurl || window.location.origin).replace(/\/+$/, "");
            serverOrigin = window.location.origin;
        }

        const candidates = [
            `${apiBase}${cleanPath}`,
            `${serverOrigin}${cleanPath}`
        ];

        return [...new Set(candidates)];
    };

    const getImageUrl = (path) => getImageCandidates(path)[0] || null;

    const handleImageError = (e, path) => {
        const candidates = getImageCandidates(path);
        const currentIndex = Number(e.currentTarget.dataset.fallbackIndex || "0");
        const nextIndex = currentIndex + 1;

        if (nextIndex < candidates.length) {
            e.currentTarget.dataset.fallbackIndex = String(nextIndex);
            e.currentTarget.src = candidates[nextIndex];
            return;
        }

        e.currentTarget.style.display = "none";
        const fallback = e.currentTarget.nextElementSibling;
        if (fallback) fallback.style.display = "flex";
    };

    const fetchDropdowns = async () => {
        try {
            const desRes = await getlist(`${config.baseurl}Designations/getlist`);
            if (desRes?.status === 200) setDesignations(desRes.data || []);

            const depRes = await getlist(`${config.baseurl}Departments/getlist`); // Assuming this endpoint exists
            if (depRes?.status === 200) setDepartments(depRes.data || []);

            const roleRes = await getlist(`${config.baseurl}Roles/getlist`);
            if (roleRes?.status === 200) setRoles(roleRes.data || []);
        } catch (error) {
            console.error("Error fetching dropdowns:", error);
        }
    };

    const validateForm = () => {
        const newErrors = {};
        if (!formState.FullName.trim()) newErrors.FullName = "Full Name is required";
        if (!formState.EmployeeCode.trim()) newErrors.EmployeeCode = "Employee Code is required";
        if (!formState.WorkEmail?.trim()) newErrors.WorkEmail = "Work Email is required";
        if (!formState.DesignationID) newErrors.DesignationID = "Designation is required";
        if (!formState.RoleName?.trim()) newErrors.RoleName = "Role Name is required";

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const openAddModal = () => {
        setFormState(initialFormState);
        setSelectedFile(null);
        setFilePreview(null);
        setFilePreviewPath("");
        setErrors({});
        setIsOpen(true);
    };

    const openEditModal = (item) => {
        console.log(item);
        setFormState({
            Id: item.id ?? item.Id ?? 0,
            EmployeeNumber: item.employeeNumber ?? item.EmployeeNumber ?? "",
            FullName: item.fullName ?? item.FullName ?? "",
            EmployeeCode: item.employeeCode ?? item.EmployeeCode ?? "",
            WorkEmail: item.workEmail ?? item.WorkEmail ?? "",
            PersonalEmail: item.personalEmail ?? item.PersonalEmail ?? "",
            Mobile: item.mobile ?? item.Mobile ?? "",
            EmploymentStatus: item.employmentStatus ?? item.EmploymentStatus ?? "",
            Gender: item.gender ?? item.Gender ?? "",
            JoiningDate: item.joiningDate ? item.joiningDate.split('T')[0] : "",
            DateOfBirth: item.dateOfBirth ? item.dateOfBirth.split('T')[0] : "",
            DesignationID: item.designationID ?? item.DesignationID ?? "",
            DepartmentID: item.departmentID ?? item.DepartmentID ?? "",
            ManagerID: item.managerID ?? item.ManagerID ?? "",
            UserID: item.userID ?? item.UserID ?? "",
            RoleName: item.roleName ?? item.RoleName ?? "",
            PhotoUrlWithPath: item.photoUrlWithPath ?? item.PhotoUrlWithPath ?? ""
        });
        const existingImagePath = item.PhotoUrlWithPath || item.photoUrlWithPath || "";
        setSelectedFile(null);
        setFilePreview(getImageUrl(existingImagePath) || null);
        setFilePreviewPath(existingImagePath);
        setErrors({});
        setIsOpen(true);

    };

    const handleFileChange = (e) => {
        if (e.target.files && e.target.files[0]) {
            const file = e.target.files[0];
            setSelectedFile(file);
            setFilePreview(URL.createObjectURL(file));
            setFilePreviewPath("");
        }
    };

    const handleSave = async () => {
        if (!validateForm()) return;
        setIsLoder(true);
        console.log("formStatsse", formState);
        const formData = new FormData();
        const nullableNumericFields = ["DesignationID", "DepartmentID", "ManagerID"];
        const requiredNumericFields = ["Id", "EmploymentStatus"];

        Object.keys(formState).forEach(key => {
            const value = formState[key];

            if (nullableNumericFields.includes(key)) {
                if (value === "" || value === null || value === undefined) return;
                const numericValue = Number(value);
                if (!Number.isNaN(numericValue)) {
                    formData.append(key, numericValue);
                }
                return;
            }

            if (requiredNumericFields.includes(key)) {
                const numericValue = Number(value);
                if (!Number.isNaN(numericValue)) {
                    formData.append(key, numericValue);
                }
                return;
            }

            if (value !== null && value !== undefined) {
                formData.append(key, value);
            }
        });

        if (selectedFile) {
            formData.append("ProfileImage", selectedFile);
        }

        try {
            const url = formState.Id > 0
                ? `${config.baseurl}Employee/update?id=${Number(formState.Id)}`
                : `${config.baseurl}Employee/add`;

            const response = await post(url, formData);
            if (response?.status === 200) {
                setIsOpen(false);
                fetchEmployees();
            } else {
                console.error("Save failed:", response);
                alert("Failed to save employee. Check console for details.");
            }
        } catch (error) {
            console.error("API Error:", error);
        } finally {
            setIsLoder(false);
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm("Are you sure you want to delete this employee?")) return;
        try {
            await deleteitem(`${config.baseurl}Employee/delete`, id);
            fetchEmployees();
        } catch (error) {
            console.error("Delete failed:", error);
        }
    };

    const paginatedData = employees.slice(
        (page - 1) * PAGE_SIZE,
        page * PAGE_SIZE
    );

    return (
        <div className="p-4 md:p-6 bg-gray-50 min-h-screen">
            <Breadcrumb pageName="Employees" currentPage="Employees" />

            <div className="bg-white rounded-xl shadow border mt-4 overflow-hidden">
                {/* HEADER */}
                <div className="card-header flex justify-between items-center px-5 py-3 border-b transition-colors duration-300
                    bg-gradient-to-r from-[#C04C2A] to-[#4A1B13]
                    dark:from-[#2D120D] dark:to-[#1A1A1A] dark:border-gray-800">

                    <div className="flex items-center gap-3">
                        <h2 className="text-xl md:text-2xl font-bold text-white tracking-tight">
                            Employee List
                        </h2>
                        {isLoder && <DotLoader color="#ffffff" size="w-1.5 h-1.5" />}
                    </div>

                    <button
                        onClick={openAddModal}
                        className="flex items-center justify-center w-10 h-10 rounded-full transition-all
                        transform hover:scale-110 active:scale-95 shadow-lg
                        bg-white dark:bg-gray-200 text-[#C04C2A] dark:text-[#4A1B13]"
                    >
                        <FontAwesomeIcon icon={faPlus} className="text-lg" />
                    </button>
                </div>

                {/* TABLE */}
                <div className="overflow-x-auto">
                    <table className="w-full text-sm">
                        <thead className="bg-gray-100">
                            <tr>
                                <th className="p-3 text-left">Code</th>
                                <th className="p-3 text-left">Name</th>
                                <th className="p-3 text-left">Email</th>
                                <th className="p-3 text-left">Designation</th>
                                <th className="p-3 text-left">Department</th>
                                <th className="p-3 text-left">Role</th>
                                <th className="p-3 text-left">Mobile</th>
                                <th className="p-3 text-right">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {paginatedData.length > 0 ? (
                                paginatedData.map(item => (
                                    <tr key={item.id || item.Id} className="border-t hover:bg-gray-50">
                                        <td className="p-3 text-gray-600">{item.employeeCode}</td>
                                        <td className="p-3 font-medium text-gray-800 flex items-center gap-2">
                                            {item.photoUrlWithPath || item.PhotoUrlWithPath ? (
                                                <div className="w-8 h-8 relative">
                                                    <img
                                                        src={getImageUrl(item.photoUrlWithPath || item.PhotoUrlWithPath)}
                                                        alt="Profile"
                                                        className="w-8 h-8 rounded-full object-cover border"
                                                        data-fallback-index="0"
                                                        onError={(e) => handleImageError(e, item.photoUrlWithPath || item.PhotoUrlWithPath)}
                                                    />
                                                    <div
                                                        className="w-8 h-8 rounded-full bg-gray-200 items-center justify-center text-gray-500"
                                                        style={{ display: "none" }}
                                                    >
                                                        <FontAwesomeIcon icon={faUser} />
                                                    </div>
                                                </div>
                                            ) : (
                                                <div className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center text-gray-500">
                                                    <FontAwesomeIcon icon={faUser} />
                                                </div>
                                            )}
                                            {item.fullName}
                                        </td>
                                        <td className="p-3 text-gray-600">{item.workEmail}</td>
                                        <td className="p-3 text-gray-600">{item.designationName}</td>
                                        <td className="p-3 text-gray-600">{item.departmentName}</td>
                                        <td className="p-3 text-gray-600">
                                            <span className="px-2 py-1 rounded-full bg-orange-100 text-orange-700 text-xs font-semibold">
                                                {item.roleName}
                                            </span>
                                        </td>
                                        <td className="p-3 text-gray-600">{item.mobile}</td>
                                        <td className="p-3 text-right space-x-3">
                                            <button
                                                onClick={() => openEditModal(item)}
                                                className="text-blue-600 hover:text-blue-800 transition-colors"
                                            >
                                                <FontAwesomeIcon icon={faEdit} />
                                            </button>
                                            <button
                                                onClick={() => handleDelete(item.id || item.Id)}
                                                className="text-red-600 hover:text-red-800 transition-colors"
                                            >
                                                <FontAwesomeIcon icon={faTrash} />
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="7" className="p-8 text-center text-gray-500">
                                        No employees found.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* MODAL */}
            {isOpen && (
                <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
                    <div
                        className="absolute inset-0 bg-black/60 backdrop-blur-sm"
                        onClick={() => setIsOpen(false)}
                    ></div>
                    <div className="bg-white dark:bg-gray-900 rounded-2xl w-full max-w-4xl p-8 relative shadow-2xl
                     transform transition-all animate-in fade-in zoom-in duration-200 max-h-[90vh] overflow-y-auto">

                        <button
                            type="button"
                            onClick={() => setIsOpen(false)}
                            className="absolute top-4 right-4 text-gray-400 hover:text-red-500 transition-colors"
                        >
                            <FontAwesomeIcon icon={faTimes} size="lg" />
                        </button>

                        <h2 className="text-2xl font-bold mb-6 text-gray-800 dark:text-white border-b pb-2">
                            {formState.Id ? "Update Employee" : "Add New Employee"}
                        </h2>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            {/* Personal Details */}
                            <div className="space-y-4">
                                <h3 className="font-semibold text-lg text-[#C04C2A]">Personal Details</h3>

                                <InputField label="Full Name" value={formState.FullName} required
                                    onChange={e => setFormState({ ...formState, FullName: e.target.value })} error={errors.FullName} />

                                <div className="grid grid-cols-2 gap-4">
                                    <InputField label="Date of Birth" type="date" value={formState.DateOfBirth}
                                        onChange={e => setFormState({ ...formState, DateOfBirth: e.target.value })} />

                                    <div>
                                        <label className="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-1">Gender</label>
                                        <select className="w-full border px-4 py-2.5 rounded-xl dark:bg-gray-800 dark:text-white outline-none focus:ring-2 border-gray-400 focus:border-[#C04C2A]"
                                            value={formState.Gender || ""}
                                            onChange={e => setFormState({ ...formState, Gender: e.target.value })}>
                                            <option value="">Select Gender</option>
                                            <option value="Male">Male</option>
                                            <option value="Female">Female</option>
                                            <option value="Other">Other</option>
                                        </select>
                                    </div>
                                </div>

                                <InputField label="Personal Email" type="email" value={formState.PersonalEmail}
                                    onChange={e => setFormState({ ...formState, PersonalEmail: e.target.value })} />

                                <InputField label="Mobile" value={formState.Mobile}
                                    onChange={e => setFormState({ ...formState, Mobile: e.target.value })} />

                                <div>
                                    <label className="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-1">Role <span className="text-red-500">*</span></label>
                                    <select className={`w-full border px-4 py-2.5 rounded-xl dark:bg-gray-800 dark:text-white outline-none focus:ring-2 ${errors.RoleName ? "border-red-500 ring-red-100" : "border-gray-400 focus:border-[#C04C2A]"
                                        }`}
                                        value={formState.RoleName || ""}
                                        onChange={e => setFormState({ ...formState, RoleName: e.target.value })}>
                                        <option value="">Select Role</option>
                                        {roles.map(r => <option key={r.id} value={r.name}>{r.name}</option>)}
                                    </select>
                                    {errors.RoleName && <p className="text-xs text-red-500">{errors.RoleName}</p>}
                                </div>

                                <div>
                                    <label className="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-1">Profile Image</label>
                                    <input type="file" accept="image/*" onChange={handleFileChange}
                                        className="w-full border px-4 py-2.5 rounded-xl dark:bg-gray-800 dark:text-white" />
                                    {filePreview && (
                                        <div className="mt-3">
                                            <img
                                                src={filePreview}
                                                alt="Preview"
                                                className="w-24 h-24 rounded-full object-cover border-2 border-gray-200"
                                                data-fallback-index="0"
                                                onError={(e) => {
                                                    if (!filePreviewPath) return;
                                                    handleImageError(e, filePreviewPath);
                                                }}
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* Work Details */}
                            <div className="space-y-4">
                                <h3 className="font-semibold text-lg text-[#C04C2A]">Work Details</h3>

                                <div className="grid grid-cols-2 gap-4">
                                    <InputField label="Employee Code" value={formState.EmployeeCode} required
                                        onChange={e => setFormState({ ...formState, EmployeeCode: e.target.value })} error={errors.EmployeeCode} />

                                    <InputField label="Employee Number" value={formState.EmployeeNumber}
                                        onChange={e => setFormState({ ...formState, EmployeeNumber: e.target.value })} />
                                </div>

                                <InputField label="Work Email" type="email" value={formState.WorkEmail} required
                                    onChange={e => setFormState({ ...formState, WorkEmail: e.target.value })} error={errors.WorkEmail} />

                                <div className="grid grid-cols-2 gap-4">
                                    <InputField label="Joining Date" type="date" value={formState.JoiningDate}
                                        onChange={e => setFormState({ ...formState, JoiningDate: e.target.value })} />

                                    <InputField label="Employment Status" value={formState.EmploymentStatus}
                                        onChange={e => setFormState({ ...formState, EmploymentStatus: e.target.value })} />
                                </div>

                                <div className="grid grid-cols-2 gap-4">
                                    <div>
                                        <label className="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-1">Designation <span className="text-red-500">*</span></label>
                                        <select className="w-full border px-4 py-2.5 rounded-xl dark:bg-gray-800 dark:text-white outline-none focus:ring-2 border-gray-400 focus:border-[#C04C2A]"
                                            value={formState.DesignationID || ""}
                                            onChange={e => setFormState({ ...formState, DesignationID: e.target.value })}>
                                            <option value="">Select Designation</option>
                                            {designations.map(d => <option key={d.id} value={d.id}>{d.name}</option>)}
                                        </select>
                                        {errors.DesignationID && <p className="text-xs text-red-500">{errors.DesignationID}</p>}
                                    </div>

                                    <div>
                                        <label className="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-1">Department</label>
                                        <select className="w-full border px-4 py-2.5 rounded-xl dark:bg-gray-800 dark:text-white outline-none focus:ring-2 border-gray-400 focus:border-[#C04C2A]"
                                            value={formState.DepartmentID || ""}
                                            onChange={e => setFormState({ ...formState, DepartmentID: e.target.value })}>
                                            <option value="">Select Department</option>
                                            {departments.map(d => <option key={d.id} value={d.id}>{d.name}</option>)}
                                        </select>
                                    </div>
                                </div>

                                <div>
                                    <label className="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-1">Manager</label>
                                    <select className="w-full border px-4 py-2.5 rounded-xl dark:bg-gray-800 dark:text-white outline-none focus:ring-2 border-gray-400 focus:border-[#C04C2A]"
                                        value={formState.ManagerID || ""}
                                        onChange={e => setFormState({ ...formState, ManagerID: e.target.value })}>
                                        <option value="">Select Manager</option>
                                        {employees.map(e => {
                                            const empId = e.id || e.Id || e.ID;
                                            return <option key={empId} value={empId}>{e.fullName || e.FullName} ({(e.employeeNumber || e.EmployeeNumber || "")})</option>;
                                        })}
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div className="flex gap-3 pt-8 justify-end">
                            <button
                                type="button"
                                onClick={() => setIsOpen(false)}
                                className="px-6 py-2.5 border border-gray-200 text-gray-600 font-bold rounded-xl hover:bg-gray-50"
                            >
                                Cancel
                            </button>
                            <button
                                type="button"
                                onClick={handleSave}
                                disabled={isLoder}
                                className="px-6 py-2.5 text-white font-bold rounded-xl shadow-lg bg-gradient-to-r from-[#C04C2A] to-[#4A1B13]"
                            >
                                {isLoder ? <DotLoader color="#fff" size="w-1.5 h-1.5" /> : (formState.Id ? "Update Employee" : "Save Employee")}
                            </button>
                        </div>

                    </div>
                </div>
            )}
        </div>
    );
}

const InputField = ({ label, type = "text", value, onChange, required, error }) => (
    <div>
        <label className="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-1">
            {label} {required && <span className="text-red-500">*</span>}
        </label>
        <input
            type={type}
            className={`w-full border px-4 py-2.5 rounded-xl dark:bg-gray-800 dark:text-white outline-none focus:ring-2 
            ${error ? "border-red-500 ring-red-100" : "border-gray-400 focus:ring-orange-100 focus:border-[#C04C2A]"}`}
            value={value || ""}
            onChange={onChange}
        />
        {error && <p className="mt-1 text-xs text-red-500 font-medium">{error}</p>}
    </div>
);
